import { useTranslation } from "react-i18next";
import { Order, OrderStatus } from "../../../../core/models/entities/Order";
import { ApprovalDisplay } from "../../../components/Approval/ApprovalDisplay";

interface Props {
  order: Order;
}

export function OrderStatusElement({ order }: Props): JSX.Element {
  const { t } = useTranslation();
  switch (order.status) {
    case OrderStatus.Unknown:
      return (
        <p className={`mb-1 font-semibold text-xs text-gray-600`}>
          {t("unknown")}
        </p>
      );
    case OrderStatus.Draft:
      return (
        <p className={`mb-1 font-semibold text-xs text-orange-400`}>
          {t("orderListDetails.statusDraft")}
        </p>
      );
    case OrderStatus.Pending:
      return <ApprovalDisplay approval={order.approval!} isOrder={true} />;
    case OrderStatus.AwaitingEntry:
      return (
        <p className="text-status-pending-1 font-semibold flex items-center space-x-2 ">
          {t("orderListDetails.statusAwaitingEntry")}
        </p>
      );
    case OrderStatus.AwaitingPayment:
      // Stripe prepayment gets its own ORANGE pill (same family as the
      // AwaitingPaymentNotice banner) — it used to be the exact same amber
      // text as "Awaiting entry", making the two states indistinguishable.
      return (
        <span
          className={
            "mb-1 inline-flex w-fit items-center rounded-full border border-orange-300 " +
            "bg-orange-50 px-2 py-0.5 text-xs font-semibold text-orange-700"
          }
        >
          {t("orderListDetails.statusAwaitingPayment")}
        </span>
      );
    case OrderStatus.Approved:
      return (
        <p className={`mb-1 font-semibold text-xs text-status-success`}>
          {t("orderListDetails.statusApproved")}
        </p>
      );
    case OrderStatus.Rejected:
      return <ApprovalDisplay approval={order.approval!} isOrder={true} />;
    case OrderStatus.InProduction:
      return (
        <p className={`mb-1 font-semibold text-xs text-status-success`}>
          {t("orderListDetails.statusInProduction")}
        </p>
      );
    case OrderStatus.OrderShipped:
      return (
        <p className={`mb-1 font-semibold text-xs text-status-success`}>
          {t("orderListDetails.statusOrderShipped")}
        </p>
      );
    case OrderStatus.Cancelled:
      return (
        <p className={`mb-1 font-semibold text-xs text-red-600`}>
          {t("orderListDetails.statusCancelled")}
        </p>
      );
    case OrderStatus.Processing:
      return (
        <p className={`mb-1 font-semibold text-xs text-blue-500`}>
          {t("orderListDetails.statusProcessing")}
        </p>
      );
    case OrderStatus.Failed:
      return (
        <p className={`mb-1 font-semibold text-xs text-red-600`}>
          {t("orderListDetails.statusFailed")}
        </p>
      );
  }

  return <></>;
}
